// Recovered compiled webpack factory 13485. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      computeCacheBustingSearchParam: function () {
        return l;
      },
      computeLegacyCacheBustingSearchParam: function () {
        return u;
      },
    }));
  let n = r(60075),
    a = new TextEncoder();
  function o(e) {
    return void 0 === e ? "0" : Array.isArray(e) ? e.join(",") : e;
  }
  function i(e, t, r, n) {
    return (void 0 === e || "0" === e) && void 0 === t && void 0 === r && void 0 === n
      ? null
      : [null != e ? e : "0", o(t), o(r), o(n)].join(",");
  }
  async function s(e) {
    var t = new Uint8Array(await globalThis.crypto.subtle.digest("SHA-256", a.encode(e))).subarray(
      0,
      12,
    );
    let r = "";
    for (let e = 0; e < t.length; e++) r += String.fromCharCode(t[e]);
    return btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
  async function l(e, t, r, n) {
    let a = i(e, t, r, n);
    return null === a ? "" : s(a);
  }
  function u(e, t, r, a) {
    let o = i(e, t, r, a);
    return null === o ? "" : (0, n.hexHash)(o);
  }
}
